module.exports = __webpack_public_path__ + "img/bule9.0a68583d.png";